import { useQuery, useMutation } from '@maui/react-query'
import { useMatiApiClient } from './client'

export const useListNotificationsQuery = (orgId, options = {}) => {
  const api = useMatiApiClient('notifications')
  return useQuery({
    queryFn: () => api.getAllNotifications(orgId),
    queryKey: ['notifications'],
    ...options
  })
}

export const useNotificationQuery = (options = {}) => {
  const api = useMatiApiClient('notifications')
  return useQuery({
    queryFn: ({ path }) => api.getNotification({ path }),
    queryKey: ['notifications'],
    ...options
  })
}

export const useCreateNotificationMutation = (options = {}) => {
  const api = useMatiApiClient('notifications')
  return useMutation({
    mutationFn: ({ orgId, payload }) => api.createNotification({ orgId, payload }),
    invalidateKeys: ['notifications'],
    ...options,
  })
}

export const useDeleteNotificationMutation = (options = {}) => {
  const api = useMatiApiClient('notifications')
  return useMutation({
    mutationFn: ({ path }) => api.deleteNotification({ path }),
    invalidateKeys: ['notifications'],
    ...options
  })
}

export const useUpdateNotificationMutation = (options = {}) => {
  const api = useMatiApiClient('notifications')
  return useMutation({
    mutationFn: ({ path, payload }) => api.updateNotification({ path, payload }),
    optimisticUpdateKey: ['notifications'],
    optimisticUpdateFn: (oldData, newData) => {
      return {
        ...oldData,
        ...newData
      }
    },
    invalidateKeys: ['notifications'],
    ...options
  })
}
